import React, { useRef, useEffect } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import {EffectCoverflow, Pagination, Keyboard, Mousewheel} from 'swiper/modules';
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./style.css";



export default function TravelSwiper() {
  const swiperRef = useRef(null);

  const slides = [
    {
      id: 1,
      type: "swiper-slide--one",
      category: "July 19",
      title: "Welcome to Dar Es Salaam",
      location: "Dar Es Salaam",
    },
    {
      id: 2,
      type: "swiper-slide--two",
      category: "July 20",
      title: "Welcome Dinner",
      location: "Dar Es Salaam",
    },
 
    {
      id: 3,
      type: "swiper-slide--four",
      category: "July 21",
      title: "Bongoyo Island Day Trip",
      location: "Bongoyo Island",
    },
       {
      id: 4,
      type: "swiper-slide--three",
      category: "July 22",
      title: "Mikumi National Park Safari (~$70/person)",
      location: "Mikumi, Morogoro",
    },
    {
      id: 5,
      type: "swiper-slide--five",
      category: "July 23",
      title: "Explore Dar Es Salaam & Slipway Resort",
      location: "Slipway Resort",
    },
       {
      id: 6,
      type: "swiper-slide--six",
      category: "July 24",
      title: "His Crew vs. Her Crew",
      location: "Dar Es Salaam",
    },
       {
      id: 7,
      type: "swiper-slide--seven",
      category: "July 25",
      title: "Wedding Day!",
      location: "Azania Front Lutheran Church",
    },
 
  ];

  return (
    <section className="itinerary">
    <h1>Itinerary</h1>
      <div className="swiper">
        <Swiper
        modules={[EffectCoverflow, Keyboard, Mousewheel]}
          ref={swiperRef}
          className="swiper-wrapper"
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={2}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2,
            slideShadows: true,
          }}
          keyboard={{ enabled: true }}
          mousewheel={{ thresholdDelta: 70 }}
          spaceBetween={120}
          loop={true}
       
        >
          {slides.map((slide) => (
            <SwiperSlide
              key={slide.id}
              className={`swiper-slide ${slide.type}`}
            >
              <span>{slide.category}</span>
              <div>
                <h2>{slide.title}</h2>
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                    />
                  </svg>
                  {slide.location}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
     
      </div>
    </section>
  );
}
